var _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcAssignment(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14.4,
    height: 16,
    viewBox: "0 0 14.4 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "ic_assignment_ind_24px",
    d: "M15.8,2.6H12.456a2.39,2.39,0,0,0-4.512,0H4.6A1.6,1.6,0,0,0,3,4.2V15.4A1.6,1.6,0,0,0,4.6,17H15.8a1.6,1.6,0,0,0,1.6-1.6V4.2A1.6,1.6,0,0,0,15.8,2.6Zm-5.6,0a.8.8,0,1,1-.8.8A.8.8,0,0,1,10.2,2.6Zm0,3.2A2.4,2.4,0,1,1,7.8,8.2,2.4,2.4,0,0,1,10.2,5.8ZM15,15.4H5.4V14.28c0-1.6,3.2-2.48,4.8-2.48s4.8.88,4.8,2.48Z",
    transform: "translate(-3 -1)",
    fill: "#586973"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcAssignment);
export default __webpack_public_path__ + "static/media/ic_assignment.4096d808.svg";
export { ForwardRef as ReactComponent };